import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CartAdditionalInfoPage } from 'src/app/modals/cart-additional-info/cart-additional-info.page';

const routes: Routes = [
  {
    path: '',
    component: CartAdditionalInfoPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CartAdditionalInfoPage]
})
export class CartAdditionalInfoPageModule {}
